import { useEffect, useState } from "react";
import { getPolicyErrorTypeList } from "utils/api/lookupApi";
import { OptionRenderType } from "controls/global/stewart-checkbox/StewartAutocompleteWithCheckboxes";

export function usePolicyErrorTypeOptions(): OptionRenderType[] {
  const [options, setOptions] = useState<OptionRenderType[]>([]);
  useEffect(() => {
    let mounted = true;
    getPolicyErrorTypeList()
      .then((rows) => {
        if (!mounted) return;
        // Guard against a non-array response (null/error payload) so we don't
        // throw "rows.filter is not a function".
        const list = Array.isArray(rows) ? rows : [];
        setOptions(
          list
            .filter((r) => r.PolicyErrorTypeName && r.PolicyErrorTypeCode)
            .map((r) => ({
              label: r.PolicyErrorTypeName,
              value: r.PolicyErrorTypeCode,
            }))
        );
      })
      .catch(() => {
        if (mounted) setOptions([]);
      });
    return () => {
      mounted = false;
    };
  }, []);
  return options;
}
